// extracted by mini-css-extract-plugin
export var filterIncDec = "_ch-0";
export var leftBorder = "_ch-1";
export var rightBorder = "_ch-2";
export var stringInput = "_ch-3";